<template>
  <div class="cp-dataset-card d-flex flex-column">
    <div
      class="cp-dataset-card-container d-flex flex-column justify-content-between"
    >
      <div class="cp-dataset-card-text">
         <router-link :to="to" class="cp-dataset-card-header">
        <span class="cp-dataset-card-header">{{ datasetTitle }}</span
        ></router-link><br />

        <p v-if="datasetDescription" class="cp-dataset-card-description">
          {{ descriptionMaxLength ? truncatedDescription : datasetDescription }}
        </p>
        <span
          v-else
          class="cp-dataset-card-description text-muted font-italic m-0"
          data-cy="dataset-description"
        >
          {{ $t("message.catalogsAndDatasets.noDescriptionAvailable") }}
        </span>
      </div>
      <div class="file-format-icons">
        <div class="file-format json">
          <span class="file-label">JSON</span>
        </div>
        <div class="file-format csv">
          <span class="file-label">CSV</span>
        </div>
        <div class="file-format shp">
          <span class="file-label">SHP</span>
        </div>
      </div>
      <div class="cp-dataset-card-icon" role="button">
        <app-link>
          <router-link :to="to" >
            <span class="show-dataset-text">Show Dataset</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              width="20"
              height="18"
              style="margin-left: 6px"
            >
              <path
                fill="#0e47cb"
                d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
              />
            </svg>
          </router-link>
        </app-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getTranslationFor, truncate } from "./helpers";
export default {
  name: "DatasetCard",
  components: {},
  props: {
    /**
     * The dataset details to display.
     */
    datasetTitle: String,
    datasetDescription: String,
    datasetCatalog: String,

    /**
     * The route to navigate to when clicking on the dataset.
     */
    to: {
      type: String,
      required: true,
    },

    /**
     * Specified the maximum length of the description before it is cut off.
     */
    descriptionMaxLength: {
      type: Number,
      default: 200,
    },

    cardIcon: String,
  },
  computed: {
    truncatedDescription() {
      return (
        this.descriptionMaxLength &&
        truncate(this.datasetDescription, this.descriptionMaxLength)
      );
    },
  },
  methods: {
    getTranslationFor,
  },
};
</script>

<style lang="scss">
.cp-dataset-card {
  padding: 25px;
  margin: 10px;
  margin-top: 0px;
  height: 500px;
  width: 300px;
  border-radius: 12px;
  background-color: #f0eded;
}
.cp-dataset-card-caption {
  font-size: 13px;
}

.cp-dataset-card-container {
  height: calc(100% - 20px);
}
.cp-dataset-card-text {
  margin-top: 5px !important;
  overflow: auto;
  margin-bottom: 15px;
}

.cp-dataset-card-header {
  font-size: 24px;
  line-height: 125%;
  color: #0e47cb !important;
  text-decoration: none !important;
}

.cp-dataset-card-header:hover {
  text-decoration: none !important;
}

.cp-dataset-card-description {
  font-size: 20px;
  margin-top: 10px;
}

.cp-dataset-card-icon {
  text-align: left !important;
}
.cp-dataset-card-icon img {
  width: 25px;
}

.cp-dataset-card-icon a {
  text-decoration: none !important;
}

.cp-dataset-card-icon a:hover {
  text-decoration: none !important;
}

.show-dataset-text {
  display: inline-block;
  font-size: 16px;
  font-weight: 640;
  color: #0e47cb;
  cursor: pointer;
}

.file-format-icons {
  display: flex;
  gap: 16px;
  margin-top: auto;
  padding-bottom: 50px;
}

.file-format {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 30px;
  border-radius: 8px;
  overflow: hidden;
}

.file-label {
  font-size: 14px;
  font-weight: bold;
  padding: 8px;
  border-radius: 2px;
  color: white;
}

.json {
  background-color: #d86b2d;
}

.csv {
  background-color: #009b77 !important;
}

.shp {
  background-color: #4a4a4a !important;
}
</style>
